import React, { useEffect, useState, createContext } from 'react'
import axios from 'axios'

const AuthContext = createContext()

const AuthContextProvider = (props) => {
    const [loggedIn, setLoggedIn] = useState(undefined)
    const [currentUser, setCurrentUser] = useState(undefined)

    const getLoggedIn = async () => {
        const res = await axios.get('/api/users/loggedIn')
        setLoggedIn(res.data)
    }

    const getCurrentUser = async () => {
        const res = await axios.get('/api/users/current')
        setCurrentUser(res.data)
    }

    useEffect(() => {
        getLoggedIn()
        getCurrentUser()
    }, [])

    return (
    <AuthContext.Provider value={{loggedIn, currentUser}}>
        {props.children}
    </AuthContext.Provider>
    )
}

export default AuthContext
export { AuthContextProvider }